import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-primary-50/60">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs md:text-sm font-label tracking-widest uppercase text-primary-600 mb-3">
            Что такое YOYbuy Sheet?
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-8">
            Ваш инструмент для умного шоппинга из Китая
          </h2>
          <div className="text-left space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              <strong>YOYbuy Sheet</strong> — это инновационный подход к организации заказов из Китая через удобные электронные таблицы. В отличие от обычных агентов по закупкам, <strong>yoybuy spreadsheet</strong> позволяет вам полностью контролировать процесс: от выбора товара до отслеживания доставки. Вы получаете прозрачную систему учёта расходов, удобный каталог категорий и возможность сравнивать цены разных поставщиков в одной таблице.
            </p>
            <p>
              Наш сервис объединяет <strong>14 категорий товаров</strong> — от обуви и одежды до аксессуаров и парфюмерии. Каждая категория в <strong>yoybuy sheet</strong> имеет собственную структуру заказа, что делает процесс максимально простым даже для новичков в международном шоппинге. Вы просто выбираете нужную категорию, заполняете таблицу заказа и получаете товары с доставкой.
            </p>
            <p>
              Многие пользователи уже оценили удобство <strong>yoybuy spreadsheet</strong> для заказа товаров из Китая. Система таблиц исключает путаницу с размерами, цветами и количеством — всё структурировано и понятно. Хотите узнать больше о том, как работает <Link to="/yoybuy-sheet-guide" className="text-primary-600 hover:text-primary-700 underline font-medium">yoybuy sheet и таблицы заказов</Link>? Читайте наше подробное руководство.
            </p>
          </div>

          <div className="mt-10">
            <span className="text-2xl md:text-3xl">✨</span>
          </div>

          <div className="mt-6">
            <Link
              to="/yoybuy-sheet-guide"
              className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              Читать полное руководство
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}